import Amplify, { Auth, Hub } from "aws-amplify";
import { config } from "../../config/config";
/**
 * User action types
 */
export const REQUEST_USER = "REQUEST_USER";
export const USER_LOADED = "USER_LOADED";
export const COGNITO_DATA_LOADED = "COGNITO_DATA_LOADED";
export const GET_USER_COUNTRY_NAME = "GET_USER_COUNTRY_NAME";
export const GET_USER_COUNTRY_NAME_SUCCESS = "GET_USER_COUNTRY_NAME_SUCCESS";
export const GET_TOKEN_SUCCESS = "GET_TOKEN_SUCCESS";
export const GET_USER_DATA = "GET_USER_DATA";

/**
 * Action for get user info based on cognito data
 * @param {*} data Cognito data
 */
export function requestUserInfo(data) {
  return function (dispatch) {
    dispatch({
      type: COGNITO_DATA_LOADED,
      payload: {
        cognito_data: data,
      },
    });

    fetch(config.api_url + config.url.users + data["username"], {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then((result) => result.json())
      .then((result) => {
        let user = result.responceObject.records[0];
        user["country_name"] = '';
        dispatch({
          type: USER_LOADED,
          payload: {
            user: user,
          },
        });
      });
  };
}

export function getUserData(data) {
  return function (dispatch) {
    fetch(config.api_url + config.url.users + data["username"], {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then((result) => result.json())
      .then((result) => {
        let user = result.responceObject.records[0];
        user["country_name"] = '';
        dispatch({
          type: GET_USER_DATA,
          payload: {
            user_data: user,
          },
        });
      });
  }
}
